var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"request-priority-badge",class:{ 'request-priority-badge_unknown': !_vm.style },style:(_vm.badgeStyle),attrs:{"title":_vm.label,"aria-label":`Приоритет: ${_vm.label}`}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }